var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"data-test":"results-count"}},[_vm._v(_vm._s(_vm.count)+" results")])}
var staticRenderFns = []

export { render, staticRenderFns }